import {Dispatch, SetStateAction} from "react";
import {IError} from "API/types";

export const useFetching = (
    callback: (args: any[]) => any,
    setIsLoading: Dispatch<SetStateAction<boolean>> = () => {},
    setError: Dispatch<SetStateAction<string>> = () => {},
) => {
    return async (...args: any[]) => {
        try {
            setError("");
            setIsLoading(true);
            await callback(args);
        } catch (e) {
            const err: IError = e as IError;
            setError(err.response.data.message);
        } finally {
            setIsLoading(false);
        }
    };
};